// CEV-S3 — the API answers 403 { code: 'ACCESS_ENDED', message } to a person whose access to HRApp
// has ended (left the company). The axios clients call notifyAccessEnded on every error; the
// AccessEndedGate shows one full-page message instead of a page full of failed requests.
export const ACCESS_ENDED_EVENT = 'hrapp.access.ended';

export function notifyAccessEnded(error) {
  try {
    const res = error && error.response;
    if (res && res.status === 403 && res.data && res.data.code === 'ACCESS_ENDED' && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(ACCESS_ENDED_EVENT, { detail: res.data.message || 'Your access to HRApp has ended.' }));
    }
  } catch {
    // never break the caller's error handling
  }
}
